export default __webpack_public_path__ + "static/media/permissions-illustration2.7184714e.svg";